export default __webpack_public_path__ + "static/media/logo-ae-jumbo.e2d88f4a.svg";